import React, { useEffect, useState } from "react";
import Flatpickr from "react-flatpickr";
import toast from "react-hot-toast";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import { fetchGenders, selectGender } from "../../redux/actions/genderActions";
import { fetchCityData, selectCity } from "../../redux/actions/citiesAction";
import { customStyles } from "../../selectStyles";
import ReactSelect from "react-select";
import axios from "../../API/axios";
import { useNavigate } from "react-router-dom";
import { Button, Modal, Row } from "react-bootstrap";
import ExcelFile from "../../assets/Wok.xlsx";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";


function EditCard() {
  const sessionId = localStorage.getItem("sessionId");
  // ...............................PROFILE Start.......................................
  // State variables
  const navigate = useNavigate();
  const [displays, setDisplays] = useState(false);
  const [langValue, setLangValue] = useState("");
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [startDate, setStartDate] = useState("");
  const [headLine, setHeadLine] = useState("");
  const [website, setWebsite] = useState("");
  const [about, setAbout] = useState("");
  const [batch, setBatch] = useState("");
  const [profileImage, setProfileImage] = useState(null);
  const [profileImageview, setProfileImageview] = useState("");

  console.log("excel", ExcelFile);

  //************************Batch Get Start  ************************//
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [selectedClass, setSelectedClass] = useState(null);
  const [batchList, setBatchList] = useState("");
  const [ClassList, setClassList] = useState("");
  console.log("selectedBatch", selectedBatch);
  const GetCandidateClass = () => {
    const data = {
      sessionId: sessionId,
      name: "",
      type: "Class",
    };
    axios
      .post(`/Institute/GetCandidateClasses`, data)
      .then((response) => {
        console.log("Class data", response.data.responseData);
        const res = response.data.responseData;
        const data = res.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        setClassList(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    GetCandidateClass();
  }, []);

  const GetCandidateBatch = () => {
    const data = {
      sessionId: sessionId,
      name: "",
      type: "Batch",
    };
    axios
      .post(`/Institute/GetCandidateClasses`, data)
      .then((response) => {
        console.log("Batch data=====>", response.data.responseData);
        const res = response.data.responseData;
        const data = res.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        setBatchList(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    GetCandidateBatch();
  }, []);

  //************************Batch Get End  ************************//

  // Handle Profile Image Change
  const handleProfileImageChange = (event) => {
    const selectedFile = event.target.files[0];
    setProfileImage(selectedFile);
    setProfileImageview(URL.createObjectURL(selectedFile));
  };

  // Common Function to handle both API calls
  const Profile = async (e) => {
    e.preventDefault();
    try {
      setDisplays(true);
      if (
        langValue &&
        firstName &&
        lastName &&
        headLine &&
        genderValue &&
        city &&
        startDate &&
        profileImage !== ""
      ) {
        // Map through selectedBatch to get an array of IDs
        const batchIDs = selectedBatch
          ? selectedBatch.map((batch) => batch.value)
          : [];

        // Create FormData for the profile submission
        const formData = new FormData();
        formData.append("LangId", langValue);
        formData.append("Email", email);
        formData.append("FirstName", firstName);
        formData.append("LastName", lastName);
        formData.append("BtchID", batchIDs.join(","));
        formData.append(
          "ClssID",
          selectedClass === null ? null : selectedClass.value
        );
        formData.append("GndrId", genderValue);
        formData.append("CityId", city);
        formData.append(
          "Dob",
          startDate ? moment(startDate).format("YYYY-MM-DD") : ""
        );
        formData.append("ProfileImage", profileImage);
        formData.append("HeadLine", headLine);
        formData.append("WebSite", website);
        formData.append("sessionId", sessionId);

        console.log("Profile FormData:", formData);

        // First API call to submit the profile data
        const res = await axios.post("/Candidate/AddByInstt", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        console.log("Profile Response:", res);

        if (res.data && res.data.message) {
          toast.success(res.data.message);
        } else {
          toast.error("Profile submission failed");
        }

        setEmail("");
        setFirstName("");
        setLastName("");
        setLangValue("");
        setStartDate("");
        setCity("");
        setGenderValue("");
        setHeadLine("");
        setWebsite("");
        setAbout("");
        setProfileImage("");
        setProfileImageview("");
        setDisplays(false);
        navigate("/InstituteCandidates");
      } else {
        toast.error("Please enter all required fields!");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  // ...............................PROFILE End.......................................

  // ...............................Gender DDL.......................................

  const [genderValue, setGenderValue] = useState(null);
  const dispatch = useDispatch();
  const { genderOptions, selectedGender } = useSelector(
    (state) => state.gender
  );
  useEffect(() => {
    dispatch(fetchGenders());
  }, [dispatch]);
  const handleGenderSelect = (selectedOption) => {
    if (selectedOption) {
      setGenderValue(selectedOption.value);
    }
  };
  // ...............................Gender DDL.......................................
  // ...............................City DDL.......................................
  const [city, setCity] = useState("null");

  const { cityList, selectedcityId } = useSelector((state) => state.cities);
  useEffect(() => {
    dispatch(fetchCityData());
  }, [dispatch]);
  const handleCitySelect = (selectedOption) => {
    if (selectedOption) {
      // dispatch(setCity(selectedOption.value));
      setCity(selectedOption.value);
    }
  };

  // ...............................City DDL.......................................

  const [showBulkModal, setShowBulkModal] = useState(false);
  const [fileName, setFileName] = useState("Wok.xlsx");
  const [selectedFile, setSelectedFile] = useState(null);

  const handleShowBulkModal = () => setShowBulkModal(true);
  const handleCloseBulkModal = () => {
    setShowBulkModal(false);
    setSelectedFile(null);
  };

  const downloadExcel = () => {
    const link = document.createElement("a");
    link.href = ExcelFile;
    link.download = fileName;
    link.click();
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFileName(file.name);
      setSelectedFile(file);
    }
  };

  const uploadFile = () => {
    if (!selectedFile) {
      alert("Please select a file to upload!");
      return;
    }
    const formData = new FormData();
    formData.append("file", selectedFile);

    console.log("Uploading file:", selectedFile.name);

    /*
    fetch("YOUR_API_ENDPOINT", {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("File uploaded successfully:", data);
      })
      .catch((error) => {
        console.error("Error uploading file:", error);
      });
    */
  };

  return (
    <>
      <div className="main-container settings">
        <div className="content-wrapper">
          <div className="title delete-title d-flex justify-content-between Title-header-Mobile">
            <h1>
              {" "}
              <span className="orange-box"></span> Add Candidate
            </h1>
            <div className="bulk-upload-container">
              <Button
                className="mainBtn apply-job"
                onClick={handleShowBulkModal}
              >
                Bulk Upload{" "}
              </Button>
            </div>
          </div>

          <div className="card delete-card EditCard d-flex align-center">
            <div className="post-job-details-form Edit-Card-details-form ">
              <div className="post-form-row">
                <div className="post-form-group">
                  <label htmlFor="type">
                    Class <span className="text-red">*</span>
                  </label>
                  <ReactSelect
                    // options={ClassList}
                    onChange={setSelectedClass}
                    // value={selectedClass}
                    placeholder="Select Class"
                    styles={customStyles}
                    classNamePrefix="react-select"
                    className="form-control"
                  />
                  {displays && !batch ? (
                    <span className="error_msg_lbl text-red">
                      Select Class{" "}
                    </span>
                  ) : null}
                </div>
                <div className="post-form-group">
                  <label htmlFor="type">Batch</label>

                  <ReactSelect
                    // options={batchList}
                    onChange={setSelectedBatch}
                    // value={selectedBatch}
                    placeholder="Select Batch"
                    styles={customStyles}
                    classNamePrefix="react-select"
                    className="form-control"
                    isMulti
                  />
                  {/* {displays && !batch ? (
                  <span className="error_msg_lbl text-red">Select Batch </span>
                ) : null} */}
                </div>
              </div>
              <div className="post-form-row">
                <div className="post-form-group">
                  <label htmlFor="category">
                    Email <span className="text-red">*</span>
                  </label>
                  <input
                    type="text"
                    id="tag"
                    placeholder="Email"
                    onChange={(e) => setEmail(e.target.value)}
                    value={email}
                    invalid={displays && email === ""}
                    className="Normal-Input-Fill"
                  />
                  {displays && !email ? (
                    <span className="error_msg_lbl text-red">Enter Email </span>
                  ) : null}
                </div>
                <div className="post-form-group">
                  <label htmlFor="type">
                    FirstName <span className="text-red">*</span>
                  </label>
                  <input
                    type="text"
                    id="tag"
                    placeholder="FirstName"
                    onChange={(e) => setFirstName(e.target.value)}
                    value={firstName}
                    invalid={displays && firstName === ""}
                    className="Normal-Input-Fill"
                  />
                  {displays && !firstName ? (
                    <span className="error_msg_lbl text-red">
                      Enter FirstName{" "}
                    </span>
                  ) : null}
                </div>
              </div>

              <div className="post-form-row">
                <div className="post-form-group">
                  <label htmlFor="tag">
                    LastName <span className="text-red">*</span>
                  </label>
                  <input
                    type="text"
                    id="tag"
                    placeholder="LastName"
                    className="Normal-Input-Fill"
                    required
                    onChange={(e) => setLastName(e.target.value)}
                    value={lastName}
                    invalid={displays && lastName === ""}
                  />
                  {displays && !lastName ? (
                    <span className="error_msg_lbl text-red">
                      Enter LastName{" "}
                    </span>
                  ) : null}
                </div>
                <div className="post-form-group">
                  <label htmlFor="gender">
                    Language <span className="text-red">*</span>
                  </label>
                  <select
                    id="gendery"
                    className="form-control Dark-Input-from-group"
                    placeholder="Gender"
                    required
                    onChange={(e) => setLangValue(e.target.value)}
                    value={langValue}
                    invalid={displays && langValue === ""}
                  >
                    <option value="">Select Language</option>
                    <option value="1">English</option>
                    <option value="2">Hindi</option>
                  </select>
                  {displays && !langValue ? (
                    <span className="error_msg_lbl text-red">
                      Select Language{" "}
                    </span>
                  ) : null}
                </div>
              </div>

              <div className="post-form-row">
                <div className="post-form-group">
                  <label htmlFor="jobApplyType">
                    Gender <span className="text-red">*</span>
                  </label>
                  <ReactSelect
                    options={genderOptions}
                    onChange={handleGenderSelect}
                    value={
                      genderOptions.find(
                        (option) => option.value === genderValue
                      ) || null
                    }
                    placeholder="Select Gender"
                    styles={customStyles}
                    classNamePrefix="react-select"
                    className="form-control"
                  />
                  {displays && !genderValue ? (
                    <span className="error_msg_lbl text-red">
                      Select Gender{" "}
                    </span>
                  ) : null}
                </div>
                <div className="post-form-group">
                  <label htmlFor="externalUrl">
                    City <span className="text-red">*</span>
                  </label>
                  <ReactSelect
                    options={cityList}
                    onChange={handleCitySelect}
                    value={
                      cityList.find((option) => option.value === city) || null
                    }
                    placeholder="Select city"
                    styles={customStyles}
                    classNamePrefix="react-select"
                    className="form-control"
                  />

                  {displays && !city ? (
                    <span className="error_msg_lbl text-red">Select City </span>
                  ) : null}
                </div>
              </div>

              <div className="post-form-row">
                <div className="post-form-group">
                  <label htmlFor="jobApplyEmail">
                    Dob <span className="text-red">*</span>
                  </label>
                  <Flatpickr
                    type="email"
                    id="jobApplyEmail"
                    placeholder="Dob"
                    onChange={(date) => setStartDate(date[0])}
                    value={startDate}
                    invalid={displays && startDate === ""}
                  />
                  {displays && !startDate ? (
                    <span className="error_msg_lbl text-red">Enter Dob </span>
                  ) : null}
                </div>
                <div className="post-form-group ">
                  <label htmlFor="salaryType">
                    ProfileImage <span className="text-red">*</span>
                  </label>
                  <input
                    type="file"
                    id="lastName"
                    className="form-control Dark-Input-from-group"
                    placeholder=""
                    onChange={(e) => {
                      handleProfileImageChange(e);
                    }}
                    invalid={displays && profileImage === ""}
                  />
                  {displays && !profileImage ? (
                    <span className="error_msg_lbl text-red">
                      Upload Image{" "}
                    </span>
                  ) : null}
                </div>
              </div>

              <div className="post-form-row">
                <div className="post-form-group">
                  <label htmlFor="minSalary">
                    HeadLine <span className="text-red">*</span>
                  </label>
                  <input
                    type="text"
                    id="minSalary"
                    placeholder="HeadLine"
                    required
                    onChange={(e) => setHeadLine(e.target.value)}
                    value={headLine}
                    invalid={displays && headLine === ""}
                    className="Normal-Input-Fill"
                  />
                  {displays && !headLine ? (
                    <span className="error_msg_lbl text-red">
                      Write Headline{" "}
                    </span>
                  ) : null}
                </div>
                <div className="post-form-group">
                  <label htmlFor="experience">Website </label>
                  <input
                    type="text"
                    id="minSalary"
                    placeholder="Website"
                    onChange={(e) => setWebsite(e.target.value)}
                    value={website}
                    invalid={displays && website === ""}
                    className="Normal-Input-Fill"
                  />
                  {/* {displays && !website ? (
                  <span className="error_msg_lbl text-red">
                    Wirte Web Name{" "}
                  </span>
                ) : null} */}
                </div>
              </div>

              <div className="post-form-row">
                <div className="post-form-group">
                  <label htmlFor="maxSalary">About</label>
                  <textarea
                    type="text"
                    id="maxSalary"
                    placeholder="About"
                    onChange={(e) => setAbout(e.target.value)}
                    value={about}
                    invalid={displays && about === ""}
                  />
                  {/* {displays && !about ? (
                  <span className="error_msg_lbl text-red">Write About </span>
                ) : null} */}
                </div>
              </div>
              <div className="avatar-upload-container">
                <div className="avatar-upload-section"></div>
                <button className="save-button" onClick={(e) => Profile(e)}>
                  Save Profile
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>


      <Modal show={showBulkModal}
        onHide={handleCloseBulkModal}
        size="md" centered
        className="Bulk-Upload-Excel-Modal"
      >
        <Modal.Header >
          <Modal.Title>Bulk Upload Excel File</Modal.Title>
          <CloseSharpIcon className="pointer" onClick={handleCloseBulkModal} />

        </Modal.Header>
        <Modal.Body>
          <div className="pt-3 ">

            <p className="text-center mb-2">Download Reference File Here</p>
            <div className="d-flex justify-content-center">

              <div className="col-md-6 ">
                <div className="Excel-File-Box"
                  style={{
                    width: "100%",
                    padding: "8px",
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    textAlign: "center",
                    backgroundColor: "#f9f9f9",
                    marginBottom: "15px",
                  }}
                >
                  <p style={{ margin: "0", fontWeight: "bold" }}>Wok.xlsx</p>
                </div>
              </div>
              <div className="col-md-3">
                <div className="khoDwnlodBtn ms-3">
                  {/* <Tooltip title="Download reference file" arrow> */}
                  <p onClick={downloadExcel}>
                    Download
                  </p>
                  {/* </Tooltip> */}
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-center">
              <input
                type="file"
                accept=".xlsx,.xls"
                onChange={handleFileUpload}
                style={{
                  marginTop: "15px",
                  // border: "1px solid #ddd",
                  padding: "5px 10px",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              />
            </div>

          </div>
        </Modal.Body>
        <div className="d-flex justify-content-end pe-3 pb-3">
          <div className="add-class-submit-button d-flex justify-content-center">
            {/* <Button variant="secondary" onClick={handleCloseBulkModal}>
                  Close
                </Button> */}
            <div className="khojPrimaryBtn ms-3">
              <a href="#/" onClick={uploadFile}>
                Upload
              </a>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default EditCard;
